import { formatDate, formatDateTime } from '@/helpers/formatDate';
import { useAuth } from '@/providers/AuthProvider';
import { Note } from '@/types';

interface NoteProps {
  initialNotes: Note[];
}

export const NotesDisplay = ({ initialNotes = [] }: NoteProps) => {
  const { user } = useAuth();
  return (
    <div className="space-y-4">
      {initialNotes.map((note, i) => (
        <div key={i} className="rounded-md border p-3 text-sm">
          <div className="flex items-center justify-between">
            <p className="font-medium">{note?.createdBy?.name || user?.name}</p>
            <p className="text-xs text-muted-foreground">
              {formatDateTime(note.createdAt)}
            </p>
          </div>
          <p className="mt-1">{note.content}</p>
        </div>
      ))}
    </div>
  );
};
